import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import { TileCarousel, type DetailTile } from '~/ui-rocco/pages/detail-shared';

/**
 * (NN) Installers — inside the spec accordion on both breakpoints (default
 * closed). The installer professionals as a headerless carousel; the accordion
 * row supplies the numbered title. On mobile the carousel bleeds out of the
 * accordion's px-5 gutter and scrolls edge-to-edge.
 */
export const InstallersRowContent = () => {
    const { product } = useLoaderData<typeof loader>();

    const installerTiles: DetailTile[] = (
        product.Installers?.professionals ?? []
    ).map((professional) => ({
        id: professional.id,
        title: professional.title,
        link: professional.link,
        images: professional.image ? [professional.image] : [],
        pinType: 'ProfessionalPin',
    }));

    return (
        <div className="pb-4 max-md:-mx-5 qhd:-mx-[calc((100vw_-_120rem)/2_+_3rem)] md:pb-[1.8rem]">
            <TileCarousel
                eyebrow=""
                ariaLabel="Installers"
                tiles={installerTiles}
                hideSubtitle
                hideHeader
                viewportClassName="max-md:px-5 qhd:px-[calc((100%_-_120rem)/2_+_3rem)]"
                itemClassName="max-md:basis-[9.8594rem]"
                contentClassName="max-md:gap-[0.5625rem]"
                tileMediaClassName="max-md:aspect-[3/4]"
            />
        </div>
    );
};
